module.exports = __webpack_public_path__ + "img/LI107369.c277fba0.svg";